import { ClaimType } from "../../store-management/claims/claim-model";
import { CLAIM_LIST_VIEW_ROUTES } from "../../store-management/shared/route-view-state.helper";

export interface ClaimTypeListNavigationTarget {
  routeKey: string;
  navigatePath: string;
  breadcrumb: string;
}

function buildTarget(
  routeKey: string,
  breadcrumb: string,
): ClaimTypeListNavigationTarget {
  return {
    routeKey,
    navigatePath: `/${routeKey}`,
    breadcrumb,
  };
}

/** Maps dashboard/API claim type keys to their dedicated list-view route. */
export function resolveClaimTypeListNavigationTarget(
  claimType: string,
): ClaimTypeListNavigationTarget | null {
  const normalized = claimType.trim();
  if (!normalized) {
    return null;
  }

  switch (normalized) {
    case ClaimType.Adjustments_Damaged:
      return buildTarget(
        CLAIM_LIST_VIEW_ROUTES.damagedInventory,
        "Damaged Inventory",
      );
    case ClaimType.Refunds_Never_Returned_FBA:
      return buildTarget(
        CLAIM_LIST_VIEW_ROUTES.refundNeverReturned,
        "Refund Never Returned Claim",
      );
    case ClaimType.ReAnalysis:
    case "ReAnalysis":
      return buildTarget(CLAIM_LIST_VIEW_ROUTES.reAnalysis, "Reanalysis Claim");
    case ClaimType.Wrong_FBA_Fees:
      return buildTarget(CLAIM_LIST_VIEW_ROUTES.storageFees, "Storage Fees");
    case ClaimType.Lost_Outbound:
      return buildTarget(
        CLAIM_LIST_VIEW_ROUTES.lostOutbound,
        "Lost Outbound Claim",
      );
    case ClaimType.Lost_Inbound:
      return buildTarget("claim/lost-inbound-guide", "Lost Inbound (Guide)");
    default:
      return null;
  }
}
